import { render, staticRenderFns } from "./authorityApply.vue?vue&type=template&id=57f0825a&scoped=true"
import script from "./authorityApply.vue?vue&type=script&lang=js"
export * from "./authorityApply.vue?vue&type=script&lang=js"
import style0 from "./authorityApply.vue?vue&type=style&index=0&id=57f0825a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f0825a",
  null
  
)

export default component.exports